module.exports = __webpack_public_path__ + "static/man-r-0b224ca0db6d20894bb1cbf75a98c509.jpg";